import styled from "styled-components"
import { ProductsDescriptionView } from "./ProductsDescription.view"

export const Wrapper = styled.div`
  display: flex;
  margin: auto;
  box-sizing: border-box;
  flex-direction: column;
  padding-bottom: 2em;
  padding-left: 2em;
  padding-right: 2em;
  max-width: 85em;
  &.mobile {
    width: 100%;
    padding: 2em;
    margin: 0;
  }
`

export const Paragraph = styled.div`
  /* ${props => props.theme.typography.p} */
  margin-bottom: 15px;
  h1 {
    text-align: center;
    margin: 0 0 15px 0;
    ${props => props.theme.typography.h1}
  }
  h2 {
    ${props => props.theme.typography.h2}
  }
  h3 {
    ${props => props.theme.typography.h3}
  }
  p {
    margin: 0;
    ${props => props.theme.typography.p}
  }
  a {
    color: black;
  }
  table {
    margin: 4em 0;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 10px #0000000d;
    border-radius: 10px;
    border-collapse: collapse;
    border-style: hidden; /* hide standard table (collapsed) border */
    box-shadow: 0 0 0 1px #d9d9d9; /* this draws the table border  */
  }
  td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  ul li {
    ${props => props.theme.typography.body}
  }
`

export const WrapperSEO = styled.div`
  background: #f2f2f2;
  max-width: none;

  > * {
    margin: auto;
    max-width: 85em;
  }

  & ${Paragraph} p {
    font-size: 0.9rem;
    text-align: justify;
  }
`
